import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { BannerEnquiryFormComponent } from '../../banner-enquiry-form/banner-enquiry-form.component';
import { CommonModule } from '@angular/common';
import { FooterComponent } from '../../../Common/footer/footer.component';
import { HeaderComponent } from '../../../Common/header/header.component';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-financial-planning',
    templateUrl: './financial-planning.component.html',
    styleUrls: ['./financial-planning.component.scss'],
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, HttpClientModule, HeaderComponent, FooterComponent, BannerEnquiryFormComponent]
})
export class FinancialPlanningComponent implements OnInit {
  baseUrl= environment.baseUrl;
  enquiryForm = new FormGroup({
    full_name: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    phone: new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(8)]),
    appointment_date: new FormControl(''),
    loan_type_id: new FormControl(2), // Set enquiryTypeId here
    organization_id: new FormControl(1),
    enq_detail_msg: new FormControl('', Validators.required)
  });

  isEnquirySubmitted = false; // Flag to track submission status

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    // Initialize component
  }

  onSubmit() {
    if (this.enquiryForm.valid) {
      const obj = {
        ...this.enquiryForm.value,
      };

      console.log('Form Submission Object:', obj); // Log the object being sent

      // Send a POST request to the API
      this.http.post(`${this.baseUrl}/add_basic_enquiry`, obj).subscribe({
        next: (res: any) => {
          console.log('Response from API:', res); // Log the API response
          if (res.success) {
            console.log('Submission successful!'); // Log success message
            this.isEnquirySubmitted = true; // Set the flag to true on success
            this.enquiryForm.reset(); // Reset the form after successful submission
              // Hide the thank you message after 5 seconds
              setTimeout(() => {
                this.isEnquirySubmitted = false;
              }, 5000);
          } else {
            console.log('Submission failed:', res); // Log the failed response
          }
        },
        error: (err: any) => {
          console.log('Error during submission:', err); // Log any errors
        },
      });
    }
  }
}
